// extracted by mini-css-extract-plugin
export default {"option":"yLiSrhTt5hjzoHkVwrb2__option___","optionlabel":"XzxSb40Hxr2v_0lLW7vr__optionlabel___","signalIcon":"zm_SpLCqYnJBq1g57nsz__signalIcon___"};